import { gql, useQuery } from '@apollo/client';

// Ids only: the navigation needs to know whether there is anything to link
// to, not the events themselves. Written inline rather than generated, as the
// answer is a single boolean and needs no generated types.
export const HAS_LIVE_EVENTS = gql`
  query HasLiveEvents {
    getEvents(data: {}) {
      events {
        id
      }
    }
  }
`;

/**
 * Whether this site has any events on sale, as the server scopes them (live,
 * and for this site). False until it knows, so a link never flashes in for a
 * site with none.
 *
 * Cache-first: the header renders on every page, and the answer only changes
 * when an event is published or taken down.
 */
const useHasLiveEvents = (): boolean => {
  const { data } = useQuery(HAS_LIVE_EVENTS, { fetchPolicy: 'cache-first' });
  return (data?.getEvents?.events?.length ?? 0) > 0;
};

export default useHasLiveEvents;
